// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"55c5fd1cb0c07b44","818":"0532c79ccf656120"}[chunkId] + ".css";
};